import { render } from "./SupportingDocsIcon.vue?vue&type=template&id=32c7ddb0&ts=true"
import script from "./SupportingDocsIcon.vue?vue&type=script&lang=ts"
export * from "./SupportingDocsIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__